import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_StudentGuidance } from "./shared/data.service";
import { StudentAddLogComponent } from "./student-add-log/student-add-log.component";
import { StudentEditLogComponent } from "./student-edit-log/student-edit-log.component";
import * as moment from "moment";

@Component({
	selector: "app-student-guidance",
	templateUrl: "./student-guidance.component.html",
	styleUrls: ["./student-guidance.component.css"],
})
export class StudentGuidanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private StudentGuidanceService: DataService_StudentGuidance,
		private dialogService: DialogService,
		private selectService: PersonSelectorService,
		private confirmationService: ConfirmationService,
		private reportService: ReportService
	) {}

	//INSERT ON INIT HERE
	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadGuidance();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	//Person Selector
	subscription: Subscription;
	SelectedPerson: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGuidance: any;
	lstGuidance: any = [];

	//Filter lists
	lstLastName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "GuidanceDTDesc", header: "Date/Time" },
		{ field: "Comments", header: "Comments" },
		{ field: "LastName", header: "Administrator" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGuidance() {
		var result = this.StudentGuidanceService.GuidanceSelectList(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstGuidance = response;

				for (var i = 0; i < this.lstGuidance.length; i++) {
					var next = this.lstGuidance[i];

					next.GuidanceDTDesc = moment(new Date(next.GuidanceDT)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstLastName = Array.from(new Set(this.lstGuidance.map((item: any) => item.LastName))).sort();
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadGuidance();
	}

	//Custom Button Methods
	onAddLog() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentAddLogComponent, {
			header: "Add Guidance Log",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedPerson: this.SelectedPerson,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGuidance();
			}
		});
	}

	onEditLog() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentEditLogComponent, {
			header: "Edit Guidance Log",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedPerson: this.SelectedPerson,
				SelectedGuidance: this.SelectedGuidance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadGuidance();
			}
		});
	}

	onDeleteLog() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedGuidance == undefined) {
			this.errorMessage = "Select a guidance log to delete";
			return;
		} else {
			//Confirm dialog
			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "Are you sure you want to delete this guidance log entry?",
				header: "Confirm Delete",
				icon: "fa",
				accept: () => {
					this.FinishDelete();
				},
			});
		}
	}

	FinishDelete() {
		//Call SP

		var result = this.StudentGuidanceService.DeleteGuidance(this.SelectedGuidance.GuidanceID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadGuidance();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Guidance Log",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onPrintLog() {
		this.errorMessage = "";

		//Error handling

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to print guidance log";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		var strParam = "";

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		var reportID: any = 202;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedGuidance = val.data;
	}
	onRowUnselect(val) {
		this.SelectedGuidance = null;
	}
	onRowDblClick(Guidance) {
		this.SelectedGuidance = Guidance;
		this.onEditLog();
	}
	////////////////////////////////////////////
}
